import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'ckeditor5';
import { element } from 'protractor';
import { combineLatest, forkJoin } from 'rxjs';
import { CardResource } from 'src/app/interfaces/card-resouce';
import { BasedatareportService } from 'src/app/services/basedatareport.service';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { CardService } from 'src/app/services/card.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-household-overview',
  templateUrl: './household-overview.component.html',
  styleUrl: './household-overview.component.scss'
})
export class HouseholdOverviewComponent {
  finishedLoadingUsers: boolean = false;

  finishedLoadingFiles: boolean = false;
  /**
   * The data to be displayed
   */
  dataSource: MatTableDataSource<any>;

  dataSourceFiles: MatTableDataSource<any>;

  /**
   * The Columns of the Table to be displayed
   */
  displayedColumns = ['number', 'ID', 'user', 'state', 'date', 'last_change', 'menu'];
  displayedColumnsFiles = ['number', 'type', 'name', 'size', 'date', 'menu'];
  constructor(
    private route: ActivatedRoute,
    private businessuserService: BusinessuserService,
    private cardService: CardService,
    private overlayService: OverlayService,
    private basedatareportService: BasedatareportService

  ) {
    this.route.params.subscribe(params => {
      combineLatest([
        this.businessuserService.getBuissnessUser(params['id']),
        this.cardService.getCardsByOwnerID(params['id']),
        this.businessuserService.getGroupMemersByID(params['id'])
      ]).subscribe(([user, cards, members]: any) => {
        this.dataSource = new MatTableDataSource(cards.content);
        let arr: Array<any> = [];
        cards.content.forEach((card: CardResource) => {
          members.forEach((member: any) => {
            if (member.publicId == card.ownerPublicId) {
              card['userModel'] = member;
            }
          });
          arr.push(this.cardService.getCardFiles(card.ownerPublicId))
        })
        combineLatest(
          arr
        ).subscribe(val => {
          let t = [];
          val.forEach(element => {
            element.producedFiles.forEach(file => {
              t.push(file)
            })
          });
          this.dataSourceFiles = new MatTableDataSource(t);
          this.finishedLoadingFiles = true;
        })
        this.finishedLoadingUsers = true;
      })
    })
  }

  /**
 * Open the Dialog to show the QR Code of the Card
 * @param card 
 */
  openQRCodeDialog(card: CardResource) {
    this.overlayService.openCardQrCodeDialog("QR-Code", "Ok", card).subscribe();
  }
  /**
   * get the Card PDF
   * @param card 
   */
  getCardPDF(card: CardResource) {
    if (card?.userModel?.person?.displayName != null && card?.userModel?.person?.displayName != '') {
      this.cardService.getPDF(card.cardId).subscribe({
        next: blob => {
          var file = new Blob([blob], { type: 'application/pdf' });
          let pdf = URL.createObjectURL(file);
          window.open(pdf)
        },
        error: err => {
          console.log(err)
        }
      })
    } else {
      this.overlayService.openDialog("Info", "Eine Kundenkarte muss zunächst von einem Kunden angefordert sein, um Aktionen auszuführen.", "Ok")
    }
  }
  /**
   * get the CardNotification as a PDF
   */
  getCardNotificationPDF(card: CardResource) {
    this.cardService.getNotiPDF(card.cardId).subscribe({
      next: blob => {
        var file = new Blob([blob], { type: 'application/pdf' });
        let pdf = URL.createObjectURL(file);
        window.open(pdf)
      },
      error: err => {
        console.log(err)
      }
    })
  }

  closeCard(card: CardResource) {
    card.state = "CLOSE_REQUEST";
    this.cardService.editCard(card).subscribe({
      next: res => {
        this.overlayService.openSnackBar("Karte erfolgreich bearbeitet!")
      },
      error: err => {
        this.overlayService.openSnackBar("Fehler beim Bearbeiten, versuchen Sie es bitte später noch einmal.");
      }
    })
  }


  reopenCard(card: CardResource) {
    card.state = "ACTIVE";
    this.cardService.editCard(card).subscribe({
      next: res => {
        this.overlayService.openSnackBar("Karte erfolgreich bearbeitet!");
      },
      error: err => {
        this.overlayService.openSnackBar("Fehler beim Bearbeiten, versuchen Sie es bitte später noch einmal.");
      }
    })
  }


  startCardProcess(type: string, publicId: string) {
    this.cardService.startCardProcess(type, publicId).subscribe({
      next: res => {
        this.overlayService.openSnackBar("Prozess erfolgreich gestartet");
      },
      error: err => {
        if (err.status == 201) {
          this.overlayService.openSnackBar("Prozess erfolgreich gestartet");
        } else {
          this.overlayService.openSnackBar("Fehler beim Starten des Prozesses, versuchen Sie es bitte später noch einmal.");

        }
      }
    })
  }

  saveFile(file) {
    this.basedatareportService.downloadReport(file.name).subscribe((reportFile) => {
      const contentType = 'application/octet-stream';
      const blob = new Blob([reportFile], { type: contentType });
      const objectUrl: string = URL.createObjectURL(blob);
      const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
      a.href = objectUrl;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl)
    })
  }


  downloadAllFiles(type: String) {
    switch (type) {
      case '1':
        this.dataSource.data.forEach(element => {
          this.getCardNotificationPDF(element)
        });
        break;
      case '2':
      this.dataSource.data.forEach(element => {
        this.getCardPDF(element)
      });
        break;
      case '3':
        this.dataSource.data.forEach(element => {
          this.getCardNotificationPDF(element)
          this.getCardPDF(element)
        });
        break;
      default:
        break;
    }
  }

}
